import React from "react";
/** @jsx jsx */
import { jsx, Box } from "theme-ui";

const Page = ({ sx, ...props }) => (
  <Box sx={{ paddingTop: "82px", ...sx }} {...props} />
);

export default Page;
